import "./ContactUs.css";

function ContactUs() {

    return (

        <div className="contact-us-page">

            <div className="contact-us-container">

                <span className="contact-tag">
                    CONTACT US
                </span>

                <h1>
                    We'd Love to Hear From You
                </h1>

                <p className="contact-description">
                    Have a question about our premium Makhana products, orders,
                    or bulk purchases? Our team is always happy to help.
                    Feel free to call or WhatsApp us during business hours.
                </p>

                <div className="contact-card">

                    <div className="contact-item">
                        <span className="contact-icon">📞</span>
                        <div>
                            <h3>Call Us</h3>
                            <p>+91 9901590606</p>
                        </div>
                    </div>

                    <div className="contact-item">
                        <span className="contact-icon">💬</span>
                        <div>
                            <h3>WhatsApp</h3>
                            <p>+91 9901590606</p>
                        </div>
                    </div>

                    <div className="contact-item">
                        <span className="contact-icon">📍</span>
                        <div>
                            <h3>Location</h3>
                            <p>Bangalore, Karnataka, India</p>
                        </div>
                    </div>

                    <div className="contact-item">
                        <span className="contact-icon">🕒</span>
                        <div>
                            <h3>Business Hours</h3>
                            <p>Monday – Saturday<br />9:00 AM – 6:00 PM</p>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    );

}

export default ContactUs;